export const MYTMPVPN_APIURL: string="https://aomqo8qwob.execute-api.ca-central-1.amazonaws.com/prod/"
